module.exports = __webpack_public_path__ + "static/media/hourglass.b891c789.svg";